import align from "suneditor/src/plugins/submenu/align";
import font from "suneditor/src/plugins/submenu/font";
import fontSize from "suneditor/src/plugins/submenu/fontSize";
import fontColor from "suneditor/src/plugins/submenu/fontColor";
import hiliteColor from "suneditor/src/plugins/submenu/hiliteColor";
import horizontalRule from "suneditor/src/plugins/submenu/horizontalRule";
import list from "suneditor/src/plugins/submenu/list";
import table from "suneditor/src/plugins/submenu/table";
import formatBlock from "suneditor/src/plugins/submenu/formatBlock";
import lineHeight from "suneditor/src/plugins/submenu/lineHeight";
import template from "suneditor/src/plugins/submenu/template";
import paragraphStyle from "suneditor/src/plugins/submenu/paragraphStyle";
import textStyle from "suneditor/src/plugins/submenu/textStyle";
import link from "suneditor/src/plugins/dialog/link";
import image from "suneditor/src/plugins/dialog/image";
import video from "suneditor/src/plugins/dialog/video";
import audio from "suneditor/src/plugins/dialog/audio";
import math from "suneditor/src/plugins/dialog/math";
import blockquote from "suneditor/src/plugins/command/blockquote";
import imageGallery from "suneditor/src/plugins/fileBrowser/imageGallery";

const allPlugins = [
  align,
  font,
  fontSize,
  fontColor,
  hiliteColor,
  horizontalRule,
  list,
  table,
  formatBlock,
  lineHeight,
  template,
  paragraphStyle,
  textStyle,
  link,
  image,
  video,
  audio,
  math,
  blockquote,
  imageGallery,
];

export default allPlugins;
